import { atom } from 'jotai';
import moment from 'moment';
import widgetLanguages from '../pages/Widget/constants/widgetLanguages';
import widgetStates from '../pages/Widget/constants/widgetStates';

const widgetDataAtom = atom({
  id: null,
  name: '',
  max_guests: null,
  slots: [],
  companyName: '',
  address: '',
  message: '',
  send_through_telegram_bot: false,
  telegram_bot_name: '',
  widget_telegram_bot_description: '',
}, (get, set, update) => {
  const newObj = { ...get(widgetDataAtom), ...update };
  set(widgetDataAtom, newObj);
});

const widgetParamsAtom = atom({
  date: new Date(),
  persons: 2,
  tag: '',
}, (get, set, update) => {
  const newObj = { ...get(widgetParamsAtom), ...update };
  set(widgetParamsAtom, newObj);
});

const widgetWithoutCloseAtom = atom(false);

const widgetInputsAtom = atom({
  slot: null,
  name: '',
  phoneNumber: '',
  comment: '',
}, (get, set, update) => {
  const newObj = { ...get(widgetInputsAtom), ...update };
  set(widgetInputsAtom, newObj);
});

const widgetDefaultsAtom = atom({
  managerPhone: '',
  languagesList: [],
}, (get, set, update) => {
  const newObj = { ...get(widgetDefaultsAtom), ...update };
  set(widgetDefaultsAtom, newObj);
});

const widgetSelectedLanguageAtom = atom(widgetLanguages.ru);

const widgetGettingLoadingAtom = atom(true);

const widgetScreenStateAtom = atom(widgetStates.slots);

const widgetSuccessScreenTextAtom = atom('');

/** Все параметры из URL виджета (query), в т.ч. colorMain и др. — для использования там, где CSS-переменные недоступны */
const widgetQueryParamsAtom = atom({});

export {
  widgetDataAtom,
  widgetParamsAtom,
  widgetGettingLoadingAtom,
  widgetSelectedLanguageAtom,
  widgetScreenStateAtom,
  widgetInputsAtom,
  widgetDefaultsAtom,
  widgetWithoutCloseAtom,
  widgetSuccessScreenTextAtom,
  widgetQueryParamsAtom,
};
